import { InjectionToken } from '@angular/core';
import { getEnvUrl } from '../../config/environment.service';

export interface VoiceConfig {
  stt: {
    url: string;
    model: string;
    /** null = autodetection (recommended for mixed es/en) */
    language: string | null;
    /** Max recording duration in ms (vLLM limits to 30s) */
    maxDurationMs: number;
  };
}

export const VOICE_CONFIG = new InjectionToken<VoiceConfig>('VoiceConfig');

export const DEFAULT_VOICE_CONFIG: VoiceConfig = {
  stt: {
    url: getEnvUrl('whisperSttUrl'),
    model: 'Systran/faster-whisper-large-v3',
    language: null,
    maxDurationMs: 30_000,
  },
};
